import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {referenceDocsAddDocTabs, documentTypes} from '../../util/uiconstants';

export default function documentReducer(state = initialstate.documents, action) {
	switch (action.type) {
		case types.GET_ALL_DOCUMENTS:
			if (action.response) {
				return action.response.data || state;
			}
			break;
		case types.GET_DOCUMENT_BY_ID: {
			// if the action has a parentName property, it is a document list related action. Do nothing.
			if (action.response && Object.keys(action.response).length > 0 && !action.parentName) {
				return state.length === 0
					? [action.response]
					: state && state.data && state.data.length > 0 && Object.keys(state?.data[0]).length > 0
					? state.data.map((doc) => (doc.id === action.response.id ? action.response : doc))
					: [action.response];
			} else {
				return state;
			}
		}
		case types.GET_ACCOUNT_BY_DOCUMENTID:
			if (action.response) {
				return action.response.data || state;
			}
			break;
		case types.GET_ALL_DOCUMENTS_SEARCH:
			if (action.response) {
				let documentList = {...action.response};
				if (documentList) {
					for (let i = 0; i < action.response.data.length; i++) {
						let document = action.response.data[i];
						document.isReturned = document.documentTypeId === documentTypes.RETURNEDDOCUMENT ? true : false;
						document.isReadOnly =
							[
								documentTypes.PRIORYEAREVIDENCE,
								documentTypes.EXTERNALDOCUMENTS,
								documentTypes.AUTOMATIONHUBOUTPUT,
								documentTypes.AUTOMATIONHUBCLIENTOUTPUT
							].indexOf(document.documentTypeId) !== -1
								? true
								: false;

						documentList.data[action.response.data[i].id] = document;
					}
				}
				return documentList || state;
			}
			break;
		case types.GET_ALL_DOCUMENTS_CLEAN:
			return {};
		case types.GET_RELATED_REFERENCE_DOCS:
			let referenceDocFilteredState = {
				data: [],
				pages: 1,
				page: 1,
				totalEntityCount: 0
			};

			let copiedDocs = _.cloneDeep(action.referenceDocuments);
			if (copiedDocs && copiedDocs.data && copiedDocs.data.length > 0) {
				let filteredDocs = copiedDocs.data.filter((doc) => {
					if (action.tabName === referenceDocsAddDocTabs.evidence) {
						return doc.parentDocumentTypeId !== 2;
					} else {
						return doc.parentDocumentTypeId === 2;
					}
				});

				if (filteredDocs && filteredDocs.length > 0) {
					if (action.searchText) {
						filteredDocs = filteredDocs.filter((doc) => {
							return doc.documentName.toLowerCase().includes(action.searchText.toLowerCase());
						});
					}

					filteredDocs.forEach((doc) => {
						doc.checked = true;
					});

					let documentsToDisplayForPage = _.take(
						_.drop(filteredDocs, action.optionPerPage * (action.currentPage - 1)),
						action.optionPerPage
					);

					referenceDocFilteredState.data = documentsToDisplayForPage;
					referenceDocFilteredState.page = action.currentPage;
					referenceDocFilteredState.pages = Math.ceil(
						action?.referenceDocuments?.totalEntityCount / action.optionPerPage
					);
					referenceDocFilteredState.totalEntityCount = filteredDocs.length;
				}
			}

			return referenceDocFilteredState;
		default:
			return state;
	}
}
